/* eslint-disable warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class InformationRoute extends Route {
  @service
  schoolSchema;

  @service
  store;

  model(params) {
    return hash({
      person: this.store.findRecord('person', params.person_id),
      groups: this.schoolSchema.getPeopleSchema(),
    });
  }
}
